import Header from './Header';

export default Header; 

/* index.js import real Header Component*/